import _lib from '../_lib';
import active from './active/index';
import {CurrentMedNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'currentmed';
  let activations = [
    {
      name: 'currentmed',
      test: api.messageIs(CurrentMedNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};